<template>
  <v-select
    v-model="value"
    :items="items"
    :item-title="itemTitle"
    :item-value="itemValue"
    :menu-props="{
      contentClass: 'options',
      location: 'right center',
    }"
    :list-props="{
      style: 'padding: 0;',
    }"
    variant="solo"
    hide-details
    single-line
    class="locale-select rtls-select rtls-select-navbar select"
    :menu-icon="null"
  >
    <template #append-inner>
      <v-icon
        role="img"
        aria-hidden="false"
        size="16"
        icon="rtls:BaseIconExpandMore"
        color="primary"
      />
    </template>
    <template #item="data">
      <v-list-item v-bind="data.props" class="slot-item">
        {{ data.item.locale }}
      </v-list-item>
    </template>
  </v-select>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';

const props = defineProps(['modelValue', 'items', 'itemTitle', 'itemValue']);
const emit = defineEmits(['update:modelValue']);

const value = computed(
  {
    get() {
      return props.modelValue;
    },
    set(updatedValue) {
      emit('update:modelValue', updatedValue);
    },
  },
  { deep: true }
);
</script>

<style lang="scss" scoped>
.locale-select {
  &.rtls-text-field {
    &.v-text-field {
      :deep(.v-field__append-inner) {
        transform: rotate(-90deg);

        .v-icon {
          max-height: 10px;
          opacity: unset;
        }
      }
    }
  }
}

.slot-item {
  min-height: 32px;

  :deep(.v-list-item-title) {
    font-size: 1.2rem;
  }
}
</style>
